import { __decorate } from "tslib";
import { customElement, property, state } from 'lit/decorators.js';
import HelixElement from '../../shared/types/helix-element.js';
import { componentStyles } from '../../shared/styles/component.styles.js';
import { localized, msg } from '@lit/localize';
import { html } from 'lit';
import '../icon/icon.js';
import { consume } from '@lit/context';
import { passwordChecklistItemStyles } from './password-checklist-item.styles.js';
import { pristineFieldContext, fieldValueContext } from './password-checklist-item-context.js';
let HlxPasswordChecklistItem = class HlxPasswordChecklistItem extends HelixElement {
    constructor() {
        super(...arguments);
        this.validateFn = () => false;
        this.isPristine = true;
    }
    render() {
        return html `
            <div part="hlx-password-checklist-item-base" class="hlx-password-checklist-item">
                ${this.isPristine ?
            html `
                        <hlx-icon
                            part="hlx-password-checklist-item-icon"
                            data-testid="pristine-icon"
                            name="circle-check"
                            fill="var(--hlx-input-help-text-color)"
                            title="${msg('Check icon')}"></hlx-icon>
                    `
            : this.validateFn(this.value) ?
                html `
                        <hlx-icon
                            part="hlx-password-checklist-item-icon"
                            data-testid="success-icon"
                            name="circle-check-filled"
                            fill="var(--hlx-progress-color-strong)"
                            title="${msg('Success check icon')}"></hlx-icon>
                    `
                : html `
                        <hlx-icon
                            part="hlx-password-checklist-item-icon"
                            data-testid="error-icon"
                            name="circle-exclamation-filled"
                            fill="var(--hlx-progress-color-poor)"
                            title="${msg('Error check icon')}"></hlx-icon>
                    `}
                <slot
                    data-testid="password-checklist-label"
                    class="hlx-password-checklist-label"></slot>
            </div>
        `;
    }
};
HlxPasswordChecklistItem.styles = [componentStyles, passwordChecklistItemStyles];
__decorate([
    property({ type: Function })
], HlxPasswordChecklistItem.prototype, "validateFn", void 0);
__decorate([
    consume({ context: pristineFieldContext, subscribe: true }),
    state()
], HlxPasswordChecklistItem.prototype, "isPristine", void 0);
__decorate([
    consume({ context: fieldValueContext, subscribe: true }),
    state()
], HlxPasswordChecklistItem.prototype, "value", void 0);
HlxPasswordChecklistItem = __decorate([
    customElement('hlx-password-checklist-item'),
    localized()
], HlxPasswordChecklistItem);
export { HlxPasswordChecklistItem };
//# sourceMappingURL=password-checklist-item.js.map